//Включает логирование всех событий. Используется для отладки.
//window.ENABLE_EVENTS_LOGGING = true;
//window.ENABLE_EVENTS_LOGGING_JQUERY = true;

(function (global) {
  "use strict";

  var includedLevels = {
    'E': ['E'],
    'W': ['E', 'W'],
    'I': ['E', 'W', 'I'],
    'D': ['E', 'W', 'I', 'D']
  }

  /** 
  * Предоставляет инструменты для логирования.
  * В режиме отладки веб-доступ записывает все действия в лог-файлы. 
  * Данные файлов впоследствии можно использовать для отладки веб-модулей.
  *
  * @namespace WebAccess.utils.log  
  * @since 5.1.0.1523
  *
  * @example 
  * WA.utils.log.info('Загружен новый веб-модуль «Модуль 1.0»');
  * // Либо использовать второй вариант записи.
  * log.info('Загружен новый веб-модуль «Модуль 1.0»');  
  */
  var Log = BaseObject.extend({
    className: "Log",
    _disabled: true,
    saveImmediate: false,
    maxStackSize: 50,
    _writeTimeOut: null,

    init: function () {
      if (!this.isDisabled()) this._disabled = false;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    strToLevel: function (level) {
      switch (level) {
        case 'error':
          return LOG_LEVEL.ERROR;
          break;
        case 'warn':
        case 'warning':
          return LOG_LEVEL.WARN;
          break;
        case 'info':
          return LOG_LEVEL.INFO;
          break;
        case 'debug':
          return LOG_LEVEL.DEBUG
          break;
        default:
          return null;
      };
    },

    getLevel: function () {
     return WA.cache.getItem('log.level') || this.strToLevel(Core.logLevel) || LOG_LEVEL.ERROR;
    },

    setLevel: function (level) {
      WA.cache.setItem('log.level', level);
      return this;
    },

    /**
    * Проверить, отключено ли логирование.
    * Значение по умолчанию True.
    *
    * @method WebAccess.utils.log.isDisabled
    * @return {Boolean} True – логирование отключено, иначе False.
    */
    isDisabled: function () {
      return (!window.isDebug && WA.cache.getItem('log.isEnabled') !== 'true');
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Включить логирование.
    * По умолчанию логирование отключено.
    * 
    * @method WebAccess.utils.log.enable
    * @return {WebAccess.utils.log} Объект типа log.
    */
    enable: function () {
      WA.cache.setItem('log.isEnabled', 'true');
      this._disabled = false;
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


    _write: function (params) {
      if (!Core.isLogsEnabled) return this;
      if (this._isDisabled) return this;
      if (WA.getLocation() === 'login') return;
      if (!params) return;
      if (this.saveImmediate) {
        WA.SRV.call('/ClientLogs.asmx/Write', params);
      } else {
        var queue = WA.cache.getObject('logs') || [];
        queue.push(params);
        WA.cache.setObject('logs', queue);
        if (queue.length > this.maxStackSize) this._writeQueue();
      }
      return this;
    },

    /**    
    * Выгрузить текущий пакет лога на веб-сервер.
    * @method WebAccess.current.statistics._writeQueue
    * @private
    */
    _writeQueue: function () {
      if (this._isDisabled) return this;
      var queue = WA.cache.getObject('logs');
      clearTimeout(this._writeTimeOut);

      this._writeTimeOut = setTimeout(function () {
        WA.SRV.call('/ClientLogs.asmx/writeQueue', { "Queue": queue }).done(function (success) {
          if (success) WA.cache.setObject('logs', []);
        });
      }, 1000);
      return this;
    },

    /**
    * Отключить логирование.
    * По умолчанию логирование отключено.
    *
    * @method WebAccess.utils.log.enable
    * @return {WebAccess.utils.log} Объект типа log.
    */
    disable: function () {
      WA.cache.setItem('log.isEnabled', 'false');
      this._disabled = true;
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Записать предупреждение в лог. 
    * По умолчанию логирование отключено.
    *
    * @method WebAccess.utils.log.warn
    * @param {string} tag Тэг 
    * @param {string} message Сообщение
    * @return {WebAccess.utils.log} Объект типа log.
    */
    warn: function (tag, message) {
      if (this._disabled) return;
      tag = tag || 'DEFAULT';
      tag = tag.toUpperCase();
      var c = arguments.length;
      return this._log(LOG_LEVEL.WARN, tag, Array.prototype.splice.call(arguments, 1, c)); //Для IE8 нужно 2 параметра в splice.
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Записать предупреждение в лог. 
    * По умолчанию логирование отключено.
    *
    * @method WebAccess.utils.log.warning
    * @param {string} tag Тэг 
    * @param {string} message Сообщение
    * @alias WebAccess.utils.log.warn
    * @return {WebAccess.utils.log} Объект типа log.
    */
    warning: function (tag, message) {
      return this.warn(tag, message);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Записать в лог информационное сообщение.
    *
    * @method WebAccess.utils.log.info
    * @param {string} tag Тэг 
    * @param {string} message Сообщение
    * @return {WebAccess.utils.log} Объект типа log.
    * @since 5.1.0.1523    
    */
    info: function (tag, message) {
      if (this._disabled) return;
      tag = tag || 'DEFAULT';
      tag = tag.toUpperCase();
      var c = arguments.length;
      return this._log(LOG_LEVEL.INFO, tag, Array.prototype.splice.call(arguments, 1, c)); //Для IE8 нужно 2 параметра в splice.
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Записать в лог сообщение об ошибке.
    *
    * @method WebAccess.utils.log.error
    * @param {string} tag Тэг 
    * @param {string} message Сообщение
    * @return {WebAccess.utils.log} Объект типа log.
    * @since 5.1.0.1523    
    */
    error: function (tag, message) {
      if (this._disabled) return;
      tag = tag || 'DEFAULT';
      tag = tag.toUpperCase();
      var c = arguments.length;
      return this._log(LOG_LEVEL.ERROR, tag, Array.prototype.splice.call(arguments, 1, c)); //Для IE8 нужно 2 параметра в splice.
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Отобразить в консоли последние сообщения, ожидающие отправки на веб-сервер.
    *
    * @method WebAccess.utils.log.showLastMessages
    * @return {WebAccess.utils.log} Объект типа log.
    */
    showLastMessages: function () {
      var queue = WA.cache.getObject('logs') || [];
      for (var i in queue) {
        var line = queue[i];
        var dt = new Date(line.Time);
        var fd = formatDateTime(dt).split(' ')[1] + ':' + dt.getSeconds() + '.' + dt.getMilliseconds();
        console.log(fd + ' ' + line.Level + ' ' + line.Tag + ' ' + line.Message);
      }

      return this;
    },

    last: function () {
      this.showLastMessages();
    },

    /**
    * Сохранить лог в файл на веб-сервере.
    *
    * @method WebAccess.utils.log.save
    * @return {WebAccess.utils.log} Объект типа log.
    */
    save: function () {
      this._writeQueue();
      return this;
    },

    /**
    * Записать в лог сообщение об отладке
    * @method WebAccess.utils.log.debug
    * @return {WebAccess.utils.log} Объект типа log.
    * @since 5.1.0.1523    
    */
    debug: function (tag, message) {
      if (this._disabled) return;
      var message

      var c = arguments.length;
      message = Array.prototype.splice.call(arguments, 1, c);

      if (c === 1) message = [tag];
      tag = (c === 1) ? 'DEFAULT' : tag;

      tag = tag.toUpperCase();

      return this._log(LOG_LEVEL.DEBUG, tag, message); //Для IE8 нужно 2 параметра в splice.
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Непосредственная обрабтка вызовов записи в журнал
    * @method WebAccess.utils.log._log
    * @return {WebAccess.utils.log}
    * @private
    * @since 5.1.0.1523    
    */
    _log: function (level, tag, messages) {
      if (includedLevels[this.getLevel()].indexOf(level) === -1) return this;

      var dt = new Date();
      var t = formatDateTime(dt).split(' ')[1] + ':' + dt.getSeconds() + '.' + dt.getMilliseconds();
      this.fire('onMessage', level, t, tag, messages);

      var params = { 'Time': new Date(), 'Tag': tag, 'Level': level, 'Message': messages.join(' ') };
      var logParams = [t, tag].concat(messages).join(' ');

      if (WA.ENV.browser.name !== 'IE') {
        switch (level) {
          case LOG_LEVEL.ERROR:
            console.error(logParams);
            break;
          case LOG_LEVEL.INFO:
            console.info(logParams);
            break;
          case LOG_LEVEL.WARN:
            console.warn(logParams);
            break;
          case LOG_LEVEL.DEBUG:
          default:
            console.log(logParams);
        }
      } else {
        console.log(logParams);
      }

      this._write(params);
      return this;
    }

    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  });

  var log = new Log();
  global.log = function () {
    log.debug.apply(log, arguments);
    //console.log.apply(this, arguments);
  };

  $.extend(global.log, log);

  window.onerror = function errorHandler(errorMsg, url, lineNumber) {
    if (!WA.ENV.isTouch()) {
      log.error('DEFAULT', format('{0} {1}:{2}', errorMsg, url, lineNumber));
    } else {
      logDebug('ERROR: ' + format('{0} {1}:{2}', errorMsg, url, lineNumber));
    }
    return false;
  }


})(window.WebAccess.utils);



//Шамов А.: Для отладки событий.
if (window.ENABLE_EVENTS_LOGGING && window.ENABLE_EVENTS_LOGGING_JQUERY) {
  var prevOn = jQuery.fn.on;
  jQuery.fn.on = function () {
    console.log('jQuery.on', arguments);
    return prevOn.apply(this, arguments);
  };

  var prevOff = jQuery.fn.off;
  jQuery.fn.off = function () {
    console.log('jQuery.off', arguments);
    return prevOff.apply(this, arguments);
  };

  var prevTrigger = jQuery.fn.trigger;
  jQuery.fn.trigger = function () {
    if (!WA.ENV.isTouch()) {
      console.log('jQuery.trigger', arguments);
    } else {
      logDebug('jQuery.trigger ' + arguments[0]);
    }
    return prevTrigger.apply(this, arguments);
  };

  var prevTriggerHandler = jQuery.fn.triggerHandler;
  jQuery.fn.triggerHandler = function () {
    if (!WA.ENV.isTouch()) {
      console.log('jQuery.triggerHandler', arguments);
    } else {
      logDebug('jQuery.triggerHandler ' + arguments[0]);
    }
    return prevTriggerHandler.apply(this, arguments);
  };
}